import React__default from 'react';
import { dataViewPage } from '@keepeek/commons';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import KButton from '../../KButtons/index.js';

var TooManyState = function (_a) {
    var dataViewKey = _a.dataViewKey;
    var t = useTranslation("refront-components").t;
    var setPage = useSetRecoilState(dataViewPage(dataViewKey));
    return (React__default.createElement(Container, { sx: {
            paddingTop: 4,
            paddingBottom: 4
        } },
        React__default.createElement(Typography, { sx: {
                marginBottom: 2
            }, variant: "h2" }, t("components.dataview.toomany-state.title")),
        React__default.createElement(Typography, { sx: {
                marginBottom: 1
            } }, t("components.dataview.toomany-state.description")),
        React__default.createElement(KButton, { variant: "outlined", style: { marginTop: "1rem" }, onClick: function () { return setPage(1); } }, t("components.dataview.toomany-state.goto"))));
};

export { TooManyState as default };
//# sourceMappingURL=index.js.map
